import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "form",
    "dialog",
    "title",
    "message",
    "confirmButton",
    "cancelButton",
  ]
  static values = {
    title: String,
    message: String,
    confirmLabel: { type: String, default: "Confirm" },
    cancelLabel: { type: String, default: "Cancel" },
  }

  connect() {
    this.confirmed = false

    if (this.hasTitleTarget && this.titleValue) {
      this.titleTarget.textContent = this.titleValue
    }
    if (this.hasMessageTarget && this.messageValue) {
      this.messageTarget.textContent = this.messageValue
    }
    if (this.hasConfirmButtonTarget) {
      this.confirmButtonTarget.textContent = this.confirmLabelValue
    }
    if (this.hasCancelButtonTarget) {
      this.cancelButtonTarget.textContent = this.cancelLabelValue
    }

    this.boundHandleCancel = this.handleCancel.bind(this)
    this.boundHandleBackdropClick = this.handleBackdropClick.bind(this)
    this.dialogTarget.addEventListener("cancel", this.boundHandleCancel)
    this.dialogTarget.addEventListener("click", this.boundHandleBackdropClick)
  }

  disconnect() {
    this.dialogTarget.removeEventListener("cancel", this.boundHandleCancel)
    this.dialogTarget.removeEventListener(
      "click",
      this.boundHandleBackdropClick,
    )
    if (this.dialogTarget.open) {
      this.dialogTarget.close()
    }
  }

  intercept(event) {
    if (this.confirmed) return

    event.preventDefault()
    event.stopPropagation()
    this.dialogTarget.showModal()
    this.confirmButtonTarget.focus()
  }

  confirm() {
    this.dialogTarget.close()
    this.confirmed = true
    this.formTarget.requestSubmit()
  }

  cancel() {
    this.dialogTarget.close()
  }

  handleCancel(event) {
    event.preventDefault()
    this.dialogTarget.close()
  }

  handleBackdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.dialogTarget.close()
    }
  }
}
